import * as firebase from 'firebase/app';
import 'firebase/firestore';

const productionConfig = {
  apiKey: 'AIzaSyAoRt_Xmv8YN7Q_0wt7daKd3tYiOIiCVrY',
  authDomain: 'pen-and-paper-utilities.firebaseapp.com',
  databaseURL: 'https://pen-and-paper-utilities.firebaseio.com',
  projectId: 'pen-and-paper-utilities',
  storageBucket: 'pen-and-paper-utilities.appspot.com',
  messagingSenderId: '695767612596',
};
const devConfig = {
  apiKey: 'AIzaSyDJemBFcG6xN4pUNdcUVD6NOQMS7USnTiU',
  authDomain: 'pen-and-paper-utilites-staging.firebaseapp.com',
  databaseURL: 'https://pen-and-paper-utilites-staging.firebaseio.com',
  projectId: 'pen-and-paper-utilites-staging',
  storageBucket: 'pen-and-paper-utilites-staging.appspot.com',
  messagingSenderId: '579473862529',
};
if (process.env.VUE_APP_FIREBASE_TARGET === 'beta') {
  firebase.initializeApp(devConfig);
} else {
  firebase.initializeApp(productionConfig);
}
firebase.firestore().settings({ });
